/**
 * Created by Andrey Popov on 9/9/22.
 */

const SnapshotBarView = function () {
    cleverapps.snapshotBar.onShowButtons = this.showButtons.bind(this);
    cleverapps.snapshotBar.onHideButtons = this.hideButtons.bind(this);
    cleverapps.snapshotBar.onUpdateAdminButton = this.updateAdminButton.bind(this);
    cleverapps.snapshotBar.onUpdate = this.update.bind(this);

    this.createContent();
    this.update();
};

SnapshotBarView.prototype.createContent = function () {
    const styles = document.createElement("style");
    styles.innerHTML = ""
        + "#snapshotbar {"
        + "    position: absolute;"
        + "    bottom: 0;"
        + "    right: 0;"
        + "    display: flex;"
        + "    flex-direction: row;"
        + "    justify-content: center;"
        + "    align-items: center;"
        + "    gap: 10px;"
        + "    padding: 10px;"
        + "    z-index: 2000;"
        + "}"
        + "#snapshotbar .snapshotbar-button {"
        + "    position: relative;"
        + "    width: 40px;"
        + "    height: 40px;"
        + "    background-color: #04AA6D;"
        + "    border-radius: 10px;"
        + "    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);"
        + "    cursor: pointer;"
        + "    display: flex;"
        + "    align-items: center;"
        + "    justify-content: center;"
        + "}"
        + "#snapshotbar .snapshotbar-button:hover {"
        + "    background-color: #039a63;"
        + "    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.15);"
        + "}"
        + "#snapshotbar .snapshotbar-button img {"
        + "    max-width: 60%;"
        + "    max-height: 60%;"
        + "}"
        + "#snapshotbar .snapshotbar-button[data-tooltip]::after {"
        + "    pointer-events: none;"
        + "    position: absolute;"
        + "    top: -5px;"
        + "    left: 50%;"
        + "    transform: translate(-50%, -100%);"
        + "    display: none;"
        + "    content: attr(data-tooltip);"
        + "    font-size: 12px;"
        + "    color: #fff;"
        + "    white-space: nowrap;"
        + "    background-color: #333;"
        + "    border-radius: 3px;"
        + "    padding: 5px;"
        + "    z-index: 10;"
        + "}"
        + "#snapshotbar .snapshotbar-button[data-tooltip]:hover::after {"
        + "    display: block;"
        + "}";
    document.head.appendChild(styles);

    this.bar = document.createElement("div");
    this.bar.id = "snapshotbar";
    document.body.appendChild(this.bar);

    if (typeof EditorMap2dBackgroundBaker !== "undefined") {
        this.bakeButton = this.createButton(bundles.dev_snapshots.urls.icon_bake, "Bake background", () => {
            new EditorMap2dBackgroundBaker(Editor.currentEditor).bake();
        });
        this.bar.appendChild(this.bakeButton);
    }

    this.makeSnapshotButton = this.createButton(bundles.dev_snapshots.urls.snapshot, "Make Snapshot\n(Alt + S)", () => {
        cleverapps.snapshotBar.photo();
    });
    this.bar.appendChild(this.makeSnapshotButton);

    if (cleverapps.config.importMode) {
        if (cleverapps.isStaging()) {
            this.downloadToLocalhost = this.createButton(bundles.dev_snapshots.urls.snapshot_download, "Import into localhost", () => {
                cleverapps.snapshots.downloadToLocalhost(cleverapps.loadedSnapshot.snapshotId);
            });
            this.bar.appendChild(this.downloadToLocalhost);
        }

        if (cleverapps.isLocalhost()) {
            this.uploadToStaging = this.createButton(bundles.dev_snapshots.urls.snapshot_upload, "Upload to staging", () => {
                cleverapps.snapshots.uploadToStaging(cleverapps.loadedSnapshot);
            });
            this.bar.appendChild(this.uploadToStaging);
        }
    }

    if (cleverapps.administrator) {
        this.gotoAdminButton = this.createButton(bundles.dev_snapshots.urls.icon_admin_mode, "Admin area", () => {
            if (cleverapps.config.features.includes("island_repair")) {
                connector.platform.openUrl(`https://stands.labsystech.ru/island_editor/?project=${cleverapps.config.name}&island=0`);
            } else if (AdministratorScene.IsAvailable()) {
                cleverapps.administrator.openAdminSceneInNewTab();
            } else {
                AdminAccess.login();
            }
        });
        this.bar.appendChild(this.gotoAdminButton);
        this.updateAdminButton();
    }
};

SnapshotBarView.prototype.createButton = function (icon, tooltip, callback) {
    icon = icon.resolve();

    const button = document.createElement("div");
    button.className = "snapshotbar-button";
    button.innerHTML = `<img src='${icon.getUrl()}'>`;

    if (tooltip) {
        button.setAttribute("data-tooltip", tooltip);
    }

    if (callback) {
        button.onclick = callback;
    }

    return button;
};

SnapshotBarView.prototype.showButtons = function () {
    this.bar.style.display = "flex";
};

SnapshotBarView.prototype.hideButtons = function () {
    this.bar.style.display = "none";
};

SnapshotBarView.prototype.update = function () {
    if (this.bakeButton) {
        this.bakeButton.style.display = cleverapps.environment.isEditorScene() ? "" : "none";
    }
    this.updateAdminButton();
};

SnapshotBarView.prototype.updateAdminButton = function () {
    if (!this.gotoAdminButton) {
        return;
    }

    const params = cleverapps.getRequestParameters(location.hash);
    const testPlayLevel = params.playLevel;

    console.log("testPlayLevel", testPlayLevel);

    // on a debug build it is the way in as well: signed out, it signs in through the sso
    const visible = testPlayLevel || !cleverapps.config.adminMode && (cleverapps.config.debugMode || AdministratorScene.IsAvailable());
    this.gotoAdminButton.style.display = visible ? "" : "none";
};